module.exports = __webpack_public_path__ + "media/images/webpage/hotels/1321/floorguide/onesence-3-69c1cff4bbfad05fedadeadc392ae1e9.webp";